import { AppState } from 'reducers'

export const root = (state: AppState) => state.states

export const states = (state: AppState) => state.states.states

export default root
